// extracted by mini-css-extract-plugin
export default {"error":"error__y_ckHJpm","button":"button__glhmibOx","text":"text__HSCJvKfY","icon":"icon__xLFIXEqP"};